module.exports = __webpack_public_path__ + "img/Yunhe_Pan@2x.20204f1f.png";